export default { version: '7.23.1' };
